import { render, staticRenderFns } from "./ManageNimbleUsers.vue?vue&type=template&id=61f1e64b&"
import script from "./ManageNimbleUsers.vue?vue&type=script&lang=js&"
export * from "./ManageNimbleUsers.vue?vue&type=script&lang=js&"
import style0 from "./ManageNimbleUsers.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports